import React from "react";
import { type Merge } from "type-fest";

import { css, cx } from "#styled-system/css";

export const Divider = React.memo(function Divider({
  className,
  length,
  orientation = "horizontal",
  ...props
}: Merge<
  React.ComponentProps<"div">,
  { length?: string; orientation?: "horizontal" | "vertical" }
>) {
  return (
    <div
      {...props}
      className={cx(
        css({
          borderColor: "#E4E4E7",
          borderStyle: "solid",
          '&[data-orientation="horizontal"]': { borderBottomWidth: "1px" },
          '&[data-orientation="vertical"]': { borderRightWidth: "1px" },
        }),
        className,
      )}
      data-orientation={orientation}
      style={
        length !== undefined
          ? orientation === "horizontal"
            ? { width: length }
            : { height: length }
          : undefined
      }
    />
  );
});
